import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return undefined;
  }

  if (profile.notifications) {
    return profile.notifications;
  } else {
    return undefined;
  }
};
//VERIFY IF THE JWT IS SET
const getMyNotificationsCount = createSelector(getData, count => count);
export default getMyNotificationsCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyNotificationsCount.js